/**
 *  支払い情報編集用モーダルコンポーネント
 */
import commonMixin from '../mixins/_common';
import modalMixin from '../mixins/_modal';
import flashMessageMixin from '../mixins/_flash_messages';
import payjpCheckout3dsecure from '../Components/_payjp_checkout_3dsecure';

const DISPLAY_MODE = {
    CONTRACT: 'contract',
    ACCOUNT: 'account',
    MENU: 'menu',
};

export default {
    name: 'modal_bill_info_editor',
    template: '#modal-bill-info-editor-template',
    data () {
        return {
            token: null,
            staffName: null,
            email: null,
            publicKey: null,
        };
    },
    props: {
        // 呼び出し元画面
        displayMode: {
            type: String,
            required: true,
        },
        // 初回決済日
        firstPaymentDay: {
            type: String,
        },
        billing: {
            type: Object,
            default: function () {
                return null;
            },
        },
        defaultCard: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    components: {
        'payjp-checkout-3dsecure': payjpCheckout3dsecure,
    },
    created: function() {
        if(this.billing){
            this.staffName = this.billing.staff_name;
            this.email = this.billing.email;
            this.publicKey = this.billing.public_key;
        }
    },
    emits: ['clicked-save-btn'],
    methods: {
        /**
         * 保存する/継続を確定するボタンクリック時処理
         */
        emitClickedSaveBtn: function (/* event */) {
            const $form = this.$refs.billingInfo;
            // 通常のHTML5バリデーションエラー
            if (!$form.checkValidity()) {
                $form.reportValidity();
                return;
            }
            var postParams =  {
                'staff_name': this.staffName,
                'email': this.email,
                'token': this.token,
            };
            this.$emit('clicked-save-btn', postParams);
        },
        /**
         * PayJpToken生成成功時処理
         */
        onTokenCreated (token) {
            this.token = token.id;
        },
        /**
         * PayJpToken生成失敗時処理
         */
        onTokenFailed (e) {
            console.error(e);
        },
        /**
         * 支払い詳細表示/非表示制御
         */
        isDispPaymentDetail: function() {
            switch (this.displayMode) {
                case DISPLAY_MODE['CONTRACT']:
                    return true;
                case DISPLAY_MODE['ACCOUNT']:
                    return false;
                case DISPLAY_MODE['MENU']:
                    return true;
            }
        },
        /**
         * フッターボタンテキストを呼び出し元ページに合わせて返却
         */
        getFooterBtnText: function() {
            switch (this.displayMode) {
                case DISPLAY_MODE['CONTRACT']:
                    return '継続を確定する';
                case DISPLAY_MODE['ACCOUNT']:
                    return '保存する';
                case DISPLAY_MODE['MENU']:
                    return '決済して利用をはじめる';
            }
        },
        /**
         * 閉じるボタン表示/非表示制御
         */
        isDispCloseBtn: function() {
            switch (this.displayMode) {
                case DISPLAY_MODE['CONTRACT']:
                    return true;
                case DISPLAY_MODE['ACCOUNT']:
                    return true;
                case DISPLAY_MODE['MENU']:
                    return false;
            }
        },
        /**
         * キャンセルボタン表示/非表示制御
         */
        isDispCancellBtn: function() {
            switch (this.displayMode) {
                case DISPLAY_MODE['CONTRACT']:
                    return true;
                case DISPLAY_MODE['ACCOUNT']:
                    return true;
                case DISPLAY_MODE['MENU']:
                    return false;
            }
        },
        /**
         * PayJpボタンテキストを呼び出し元ページに合わせて返却
         */
        getPayJpBtnText: function () {
            // PayJpボタンテキスト定義
            if(this.token) {
                // カード情報が既に存在する
                return 'カード情報を変更する';
            } else {
                // 存在しない
                return 'カード情報を入力する';
            }
        },

    }
};
